import { get } from './_core.js';

export type CostGroupBy = 'user' | 'module' | 'provider' | 'model' | 'kind' | 'day';

export interface CostBucket {
  date: string;
  bucket: string | null;
  totalCostNano: string;
  callCount: number;
  errorCount: number;
}

export async function fetchCosts(opts: {
  from?: string;
  to?: string;
  groupBy?: CostGroupBy;
} = {}): Promise<CostBucket[]> {
  const params = new URLSearchParams();
  if (opts.from) params.set('from', opts.from);
  if (opts.to) params.set('to', opts.to);
  if (opts.groupBy) params.set('group_by', opts.groupBy);
  const qs = params.toString();
  const res = await get<CostBucket[]>(`/admin/costs/daily${qs ? `?${qs}` : ''}`);
  return res.data;
}
